import { useState, useEffect, useCallback } from "react";

const KEY = "blokista_watchlist";

function read() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); }
  catch { return []; }
}

// Client-side (localStorage) watchlist of starred addresses (tokens/contracts).
export function useWatchlist() {
  const [list, setList] = useState(read);

  useEffect(() => {
    const onStorage = (e) => { if (e.key === KEY) setList(read()); };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const isStarred = useCallback((a) => !!a && list.includes(a.toLowerCase()), [list]);

  const toggle = useCallback((a) => {
    if (!a) return;
    const al = a.toLowerCase();
    setList((prev) => {
      const next = prev.includes(al) ? prev.filter((x) => x !== al) : [...prev, al];
      localStorage.setItem(KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  return { list, isStarred, toggle };
}
